import React from "react";
import DocumentUpload from "../../../../components/DocumentUpload";
import { renderFields } from "../../UploadDetailsData";
import { UTILITY_FIELDS } from "../../UploadDetailsFields";
import "./index.scss";

const UtilityForm = ({
  isGSTRegistered,
  formData,
  errors,
  handleChange,
  handleBlur,
  utilityFile,
  handleUtilityFileChange,
  existingUtilityFile,
  onViewExisting,
  readOnly = false,
  isDeficient = false,
  isUploading = false,
}) => {
  if (isGSTRegistered !== "no") return null;

  // Show upload zone when: edit mode OR doc is deficient (needs re-upload)
  const showUpload = !readOnly || isDeficient;

  return (
    <div
      className={`utility-form-section${isDeficient ? " utility-form-section--deficient" : ""}`}
    >
      {isDeficient && (
        <div className="deficiency-notice">
          ⚠ Deficiency — please re-upload the Utility Bill
        </div>
      )}
      <p className="utility-note">
        Since GST is not registered, please provide utility bill details as
        address proof.
      </p>
      <div className="form-grid">
        {renderFields(
          UTILITY_FIELDS,
          formData,
          errors,
          readOnly && !isDeficient ? undefined : handleChange,
          readOnly && !isDeficient ? undefined : handleBlur,
        )}
      </div>
      {/* Upload zone — shown in edit mode or when doc is deficient */}
      {showUpload && (
        <div
          className={`doc-upload-row${isDeficient ? " doc-deficient-wrap" : ""}`}
        >
          <DocumentUpload
            label="Utility Bill Document"
            name="utility_file"
            file={utilityFile}
            existingFile={existingUtilityFile || null}
            onViewExisting={onViewExisting}
            onChange={(e) => {
              if (isUploading) return;
              const file = e.target.files[0];
              if (!file) return;
              handleUtilityFileChange(file);
            }}
            required={false}
            disabled={isUploading}
            isUploading={isUploading}
            className={isDeficient ? "doc-upload--deficient" : ""}
          />
          {isDeficient && (
            <span className="doc-deficient-label">
              ⚠ Deficiency — please re-upload
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default UtilityForm;
